export default __webpack_public_path__ + "static/media/slide5.7035a3dc.png";